import { SubscriptionService } from "./subcription.service";

export const subscriptionService = new SubscriptionService()